import PropTypes from 'prop-types'

const AllBlocksPropType = PropTypes.shape({
  0: PropTypes.array,
  5: PropTypes.array,
  10: PropTypes.array,
  15: PropTypes.array,
  20: PropTypes.array,
  25: PropTypes.array,
  30: PropTypes.array,
  35: PropTypes.array,
  40: PropTypes.array,
  45: PropTypes.array,
  50: PropTypes.array,
  55: PropTypes.array,
  60: PropTypes.array,
})

export default AllBlocksPropType
